const KEYS_MARKER_RE = /\[keys:\s*([^\]]+)\]/g;
const DIGIT_RUN_RE = /\d{3,}/g;
export const TRANSCRIPT_SECRET_MASK = "••••";
/**
 * Collects digit runs the caller keyed into the IVR. Menu presses are single
 * digits; anything 3+ digits long is an identifier (patient ID, SSN last 4).
 */
export function findTranscriptSecrets(text) {
    if (!text)
        return [];
    const secrets = new Set();
    for (const marker of text.matchAll(KEYS_MARKER_RE)) {
        for (const run of marker[1].matchAll(DIGIT_RUN_RE)) {
            secrets.add(run[0]);
        }
    }
    return [...secrets].sort((a, b) => b.length - a.length);
}
function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
/** Builds a matcher for every secret, longest first so a short one never splits a long one. */
export function buildTranscriptSecretPattern(secrets) {
    if (secrets.length === 0)
        return null;
    return new RegExp(`(?<!\\d)(?:${secrets.map(escapeRegExp).join("|")})(?!\\d)`, "g");
}
/** Replaces keyed identifiers wherever they appear, including the IVR's spoken readback. */
export function maskTranscriptSecrets(text, mask = TRANSCRIPT_SECRET_MASK) {
    if (!text)
        return "";
    const pattern = buildTranscriptSecretPattern(findTranscriptSecrets(text));
    return pattern ? text.replace(pattern, mask) : text;
}
